import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Flex, FormField, TextInput, Checkbox } from '@percent/lemonade';
import { Card } from '@percent/hosted-validation-form/ui';
import { useValidationStepData } from '../../validationStepContext/useValidationStepData/useValidationStepData';
import { HostedFormStep } from '../../HostedForm.types';
import { usePartnerConfig, useProgress } from '@percent/hosted-validation-form/hooks';

type FormFieldValues = {
  website: string;
  withoutWebsite: string | boolean;
  registryName: string;
};

export const Website = () => {
  const { partnerConfig } = usePartnerConfig();
  const { progress } = useProgress();
  const { setOrganisation, organisation, handleNext, handleBack } = useValidationStepData();
  const { t } = useTranslation();

  const {
    getValues,
    setValue,
    clearErrors,
    register,
    formState: { errors, dirtyFields },
  } = useFormContext<FormFieldValues>();

  const handleNavigateNext = () => {
    const website = getValues('website');

    if (organisation && website) {
      setOrganisation({ ...organisation, website });
    }

    if (website) {
      setValue('withoutWebsite', '');
    }

    if (partnerConfig?.configuration.avCheckAvailable !== undefined && !partnerConfig?.configuration.avCheckAvailable) {
      const hasPartnerFields = !!partnerConfig?.configuration?.partnerFields?.length;

      if (hasPartnerFields) {
        return handleNext(HostedFormStep.PARTNER_FIELDS);
      }
      return handleNext(HostedFormStep.TERMS);
    } else {
      return handleNext(HostedFormStep.CONTACT_DETAILS);
    }
  };

  const handleNavigateBack = () => {
    setValue('website', '');
    handleBack();
  };

  const isNextButtonDisabled =
    (errors.website || !dirtyFields.website || (!getValues('withoutWebsite') && getValues('website') === '')) &&
    !getValues('withoutWebsite');

  return (
    <Card
      onBack={handleNavigateBack}
      title={t('hostedValidation.title.haveWebsite')}
      description={t('hostedValidation.title.enterWebsite')}
      onNext={handleNavigateNext}
      nextButtonLabel={t('hostedValidation.button.next')}
      nextButtonDisabled={isNextButtonDisabled}
      progress={progress}
    >
      <Flex direction="column" gap={16} w="100%">
        <FormField
          label={t('hostedValidation.label.website')}
          status={errors.website?.message ? 'danger' : 'default'}
          statusMessage={errors.website?.message}
          disabled={!!getValues('withoutWebsite')}
        >
          <TextInput {...register('website')} placeholder={t('hostedValidation.placeholder.website')} />
        </FormField>
        {!getValues('registryName') && (
          <Checkbox
            name="withoutWebsite"
            variant="default"
            onChange={(event) => {
              const isChecked = (event as React.ChangeEvent<HTMLInputElement>).target.checked;

              setValue('website', '');
              if (isChecked) {
                clearErrors('website');
              }
              if (organisation) {
                setOrganisation({ ...organisation, website: '' });
              }

              setValue('withoutWebsite', isChecked);
            }}
            active={!!getValues('withoutWebsite')}
            label={t('hostedValidation.label.noWebsite')}
          />
        )}
      </Flex>
    </Card>
  );
};
